import { defineStore } from "pinia";
import ApiService from "~/services/ApiService";
import { useAuthStore } from "~/stores/auth";
import { useBonusStore } from "~/stores/bonus";
import { useAlert } from "~/stores/alert";
import { useDepositStore } from "~/stores/deposit";

export const useCouponStore = defineStore("coupon", () => {
  const { showAlert } = useAlert();

  const authStore = useAuthStore();
  const bonusStore = useBonusStore();
  const depositStore = useDepositStore();

  // Use useState alone for simpler access pattern
  const isCouponModalActive = useState('couponModalActive', () => false);
  const coupons = useState('coupons', () => []);
  const isCouponApplied = useState('couponApplied', () => false);
  const activatedCoupon = useState('activatedCoupon', () => "");
  const isCouponInputVisible = useState('couponInputVisible', () => false);
  const couponError = useState('couponError', () => "");
  const isCouponLoading = useState('couponLoading', () => false);
  const couponModel = useState('couponModel', () => "");
  const couponText = useState('couponText', () => "");

  function selectCoupon(coupon) {
    isCouponInputVisible.value = false;
    isCouponApplied.value = true;
    couponError.value = "";
    isCouponLoading.value = false;
    activatedCoupon.value = coupon;
    showAlert("success", "Cupom ativado com sucesso");
  }

  function toggleCouponModal() {
    isCouponModalActive.value = !isCouponModalActive.value;
  }

  async function applyCouponCode(couponCode) {
    if (
      coupons.value.filter(
        (coupon) =>
          coupon.coupon.code.toLowerCase() === couponCode.toLowerCase()
      ).length > 0
    ) {
      let selectedCoupon = coupons.value.filter(
        (coupon) =>
          coupon.coupon.code.toLowerCase() === couponCode.toLowerCase()
      )[0];
      console.log("Cupom já aplicado.", selectedCoupon);

      if (selectedCoupon?.coupon?.deposit) {
        selectCoupon(selectedCoupon);
      }

      return selectedCoupon;
    }

    return new Promise(async (resolve, reject) => {
      await ApiService.post(`/api/coupons/apply`, { code: couponCode })
        .then(async (response) => {
          if (response.data.error) {
            reject(response.data.message);
          }

          if (response.status === 500) {
            reject("Ocorreu um erro tente novamente.");
          }

          if (response.error) {
            reject(response.data.message);
          }

          await getCoupons();
          await bonusStore.getRollovers();
          await authStore.getUser();

          if (response.data?.userCoupon?.coupon?.deposit) {
            selectCoupon(response.data?.userCoupon);
          }

          resolve(response.data?.userCoupon);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  async function submitCouponCode(couponCode) {
    try {
      couponError.value = "";

      if (!couponCode) {
        couponError.value = "Insira um cupom válido";
        return;
      }

      isCouponLoading.value = true;

      const coupon = await applyCouponCode(couponCode);

      activatedCoupon.value = coupon;
      isCouponApplied.value = true;
      showAlert("success", "Cupom ativado com sucesso");

      if (depositStore.$state.isModalOpen) {
        if (!coupon.coupon.deposit) {
          removeCoupon();
          resetCouponInput();
          depositStore.toggleModal();
          navigateTo("/user/bonus");
        }
      }
    } catch (error) {
      console.log(error);
      couponError.value = error;
      showAlert("error", error);
    } finally {
      if (isCouponApplied.value) {
        setTimeout(() => {
          isCouponLoading.value = false;
        }, 1500);

        if (!depositStore.$state.isModalOpen) {
          toggleCouponModal();
          removeCoupon();
          resetCouponInput();
        } else {
          isCouponInputVisible.value = false;
        }
      } else {
        isCouponLoading.value = false;
      }
    }
  }

  function resetCouponInput() {
    couponError.value = "";
    couponModel.value = "";
  }

  function removeCoupon() {
    isCouponApplied.value = false;
    couponModel.value = "";
    clearCoupon();
  }

  function setLatestCoupon() {
    if (coupons.value.length <= 0) {
      return;
    }

    const gambeta = coupons.value.filter((coupon) => coupon.coupon.event === 1 && coupon.coupon.apply_register === 1);

    if (gambeta.length <= 0) {
      return;
    }

    activatedCoupon.value = gambeta[gambeta.length - 1];
    isCouponApplied.value = true;
  }

  async function getCoupons() {
    await ApiService.post("/api/coupons/list", {
      active: false,
      applied: true,
      expired: true
    }).then((response) => {

      if (response.data.userCoupons) {
        coupons.value = response.data?.userCoupons;

        setLatestCoupon();
      }
    });
  }

  async function getCouponText() {
    try {
      const response = await useFetch("/v2/coupons/register");

      if (response.data.value.text) {
        couponText.value = response.data.value.text;
      }

      // couponText.value = "";

      // const response = await useFetch('/v2/coupons/onRegister', {
      //   transform: (res) => ({ value: res }),
      // });

      // if (response.status.value !== 'success') {
      //   couponText.value = "";
      //   return;
      // }

      // couponText.value = response.data.value?.text ?? "";
    } catch (error) {
      couponText.value = "";
      console.error("Failed to fetch on-register coupon:", error);
    }
  }

  function clearCoupon() {
    activatedCoupon.value = "";
    isCouponApplied.value = false;

  }

  return {
    // state
    coupons,
    isCouponModalActive,
    activatedCoupon,
    isCouponApplied,
    isCouponInputVisible,
    couponError,
    couponModel,
    isCouponLoading,
    couponText,

    // actions
    toggleCouponModal,
    applyCouponCode,
    getCoupons,
    clearCoupon,
    selectCoupon,
    removeCoupon,
    resetCouponInput,
    submitCouponCode,
    getCouponText
  };
});
